import { Component } from '../../../engine/ecs/core/Component';

/**
 * Pacman movement directions
 */
export enum Direction {
  Up = 'up',
  Down = 'down',
  Left = 'left',
  Right = 'right',
  None = 'none',
}

/**
 * PacmanComponent - Data for the Pacman player character
 * Pure data component following ECS principles
 */
export class PacmanComponent extends Component {
  public currentDirection: Direction;
  public nextDirection: Direction;
  public speed: number;
  public isAlive: boolean;
  public isEating: boolean;
  public eatingTimer: number;
  public invulnerabilityTimer: number;
  public lives: number;
  public score: number;
  public isSuperMode: boolean; // Power pellet mode (can eat ghosts)

  constructor(speed: number = 130, lives: number = 3) {
    super();
    this.currentDirection = Direction.None;
    this.nextDirection = Direction.None;
    this.speed = speed;
    this.isAlive = true;
    this.isEating = false;
    this.eatingTimer = 0;
    this.invulnerabilityTimer = 0;
    this.lives = lives;
    this.score = 0;
    this.isSuperMode = false;
  }

  public clone(): PacmanComponent {
    const clone = new PacmanComponent(this.speed, this.lives);
    clone.currentDirection = this.currentDirection;
    clone.nextDirection = this.nextDirection;
    clone.isAlive = this.isAlive;
    clone.isEating = this.isEating;
    clone.eatingTimer = this.eatingTimer;
    clone.invulnerabilityTimer = this.invulnerabilityTimer;
    clone.score = this.score;
    clone.isSuperMode = this.isSuperMode;
    return clone;
  }
}
